import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { PickFirstPipe } from '../core/pipes/pick-first.pipe';
import { currencyFormatPipe } from '../core/pipes/currency-format.pipe';
import { StatusFormatPipe } from '@core/pipes/status-format.pipe';
import { DateFormatPipe } from '@core/pipes/date-format.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@core/pipes/translate.pipe';
import { HasAnyRoleDirective, HasRoleDirective } from './directives';

@NgModule({
  declarations: [
    PickFirstPipe,
    currencyFormatPipe,
    StatusFormatPipe,
    DateFormatPipe,
    TranslatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    HasRoleDirective,
    HasAnyRoleDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    PickFirstPipe,
    currencyFormatPipe,
    StatusFormatPipe,
    DateFormatPipe,
    TranslatePipe,
    HasRoleDirective,
    HasAnyRoleDirective,
  ],
  providers: [
    MessageService,
  ]
})
export class SharedModule { }
